import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { ApiBaseUrl } from "../../http";
import { QueryUrl } from "../../Utils";
import { AlertFormdata, IAlert } from "./alert.type";

const AlertApi = createApi({
  reducerPath: "alertApi",
  tagTypes: ["alert"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${ApiBaseUrl}/api/`,
    prepareHeaders,
  }),
  endpoints: (build) => ({
    getAlert: build.query<PaginationResults<IAlert>, TypeQuery>({
      query: (query) => QueryUrl("alertes", query),
      providesTags: ["alert"],
    }),
    addOrUpdateAlert: build.mutation<IAlert, { slug?: string; data: IAlert }>({
      query: ({ slug, data }) => ({
        url: slug ? `alertes/${slug}/` : `alertes/`,
        method: slug ? "PUT" : "POST",
        body: data,
      }),
      invalidatesTags: ["alert"],
    }),
    deleteAlert: build.mutation<AlertFormdata, string>({
      query: (slug) => ({
        url: `alertes/${slug}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["alert"],
    }),
  }),
});

export default AlertApi;

export const { useGetAlertQuery,
  useAddOrUpdateAlertMutation,
  useDeleteAlertMutation
 } = AlertApi;
